(function (angular) {
	'use strict';

	angular.module('placeholderModule', []);
})(window.angular);